"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingAgreementReducerFunction = exports.billingAgreementActions = exports.billingAgreementState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
exports.initialState = {
    MandatSepaURL: null,
    billingAgreements: {
        data: null,
        loading: false,
        customerAccountId: null
    },
    iban: {
        value: null,
        withdrawalDate: null,
        numberOfPeople: null,
        loading: false,
        status: 'none',
        monthlyEstimation: null
    },
    billingAddress: {
        data: null,
        loading: false,
        status: 'none'
    },
    activateDirectDebit: {
        eBill: false,
        loading: false,
        wasDirectDebitAtMaturity: false,
        active: false
    },
    activateDirectDebitAtMaturity: {
        eBill: false,
        loading: false,
        active: false
    },
    activateElectronicInvoice: {
        sent: false,
        eBill: false,
        loading: false,
        active: false
    },
    terminateElectronicInvoice: {
        sent: false,
        eBill: false,
        loading: false,
        active: false
    },
    monthlyEstimate: {
        loading: false,
        monthlyEstimateData: null,
        responseCode: null,
        errorMessage: null,
        success: false
    }
};
var billingAgreementState = /** @class */ (function (_super) {
    __extends(billingAgreementState, _super);
    function billingAgreementState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    billingAgreementState.prototype.fetchBillingAgreementsAndScheduledInstalments = function (customerAccountId) {
        this.draftState.billingAgreements.loading = true;
        this.draftState.billingAgreements.data = null;
        this.draftState.activateDirectDebit.active = false;
        this.draftState.iban.value = null;
        this.draftState.activateElectronicInvoice.active = false;
        this.draftState.billingAgreements.errorMessage = null;
    };
    billingAgreementState.prototype.fetchBillingAgreementsAndScheduledInstalmentsError = function (errorMsg) {
        this.draftState.billingAgreements.loading = false;
        this.draftState.billingAgreements.errorMessage = errorMsg;
        this.draftState.billingAgreements.data = null;
        this.draftState.activateDirectDebit.active = false;
        this.draftState.iban.value = null;
        this.draftState.activateElectronicInvoice.active = false;
    };
    billingAgreementState.prototype.fetchBillingAgreementsAndScheduledInstalmentsSuccess = function (response) {
        this.draftState.billingAgreements.loading = false;
        this.draftState.billingAgreements.data = response;
        this.draftState.activateDirectDebit.active = response.directDebit;
        this.draftState.iban.value = response.iban;
        this.draftState.activateElectronicInvoice.active =
            response.dematerialization;
        this.draftState.billingAgreements.errorMessage = null;
    };
    billingAgreementState.prototype.setPaymentInformation = function (iban, withdrawalDate, numberOfPeople, monthlyEstimation) {
        this.draftState.iban.value = iban;
        this.draftState.iban.withdrawalDate = withdrawalDate;
        this.draftState.iban.numberOfPeople = numberOfPeople;
        this.draftState.iban.monthlyEstimation = monthlyEstimation;
    };
    //FIXME: temporary for business while waiting for HOT DATA
    billingAgreementState.prototype.setIban = function (iban) {
        this.draftState.iban.value = iban;
        if (this.draftState.billingAgreements.data) {
            this.draftState.billingAgreements.data.iban = iban;
        }
    };
    billingAgreementState.prototype.getBillingAgreement = function (customerAccountId) {
        this.draftState.billingAgreements.loading = true;
    };
    billingAgreementState.prototype.getBillingAgreementFailure = function (errorMessage) {
        this.draftState.billingAgreements.loading = false;
        this.draftState.billingAgreements.errorMessage = errorMessage;
    };
    billingAgreementState.prototype.getBillingAgreementSuccess = function (billingAgreement) {
        this.draftState.billingAgreements.loading = false;
        this.draftState.billingAgreements.data = billingAgreement;
        this.draftState.billingAgreements.errorMessage = null;
    };
    /**
     * Permet d'activer le prélèvement mensuel et la facture éléctronique en même temps
     * @param payload Paramètres pour l'activation de l'option
     */
    billingAgreementState.prototype.activateDirectDebit = function (payload) {
        this.draftState.activateDirectDebit.eBill = payload.Ebill;
        this.draftState.activateDirectDebit.loading = true;
    };
    /**
     * Permet d'activer le prélèvement mensuel et la facture éléctronique en même temps
     * @param payload Paramètres pour l'activation de l'option
     */
    billingAgreementState.prototype.activateDirectDebitWithEstimate = function (payload) {
        this.draftState.activateDirectDebit.eBill = payload.Ebill;
        this.draftState.activateDirectDebit.loading = true;
    };
    /**
     * Action pour passer du prélèvement à échéancce au prélèvement mensuel
     * @param payload Données à envoyer à l'API
     */
    billingAgreementState.prototype.switchFromDirectDebitAtMaturityToMonthlyWithEstimate = function (payload) {
        this.draftState.activateDirectDebit.eBill = payload.Ebill;
        this.draftState.activateDirectDebit.loading = true;
    };
    /**
     * Action pour passer du prélèvement à échéancce au prélèvement mensuel
     * @param payload Données à envoyer à l'API
     */
    billingAgreementState.prototype.switchFromDirectDebitAtMaturityToMonthly = function (payload) {
        this.draftState.activateDirectDebit.eBill = payload.Ebill;
        this.draftState.activateDirectDebit.loading = true;
    };
    billingAgreementState.prototype.activateDirectDebitAtMaturity = function (payload) {
        this.draftState.activateDirectDebitAtMaturity.eBill = payload.Ebill;
        this.draftState.activateDirectDebitAtMaturity.loading = true;
    };
    billingAgreementState.prototype.activateDirectDebitAtMaturitySuccess = function (demat) {
        this.draftState.activateDirectDebitAtMaturity.loading = false;
        this.draftState.iban.value = null;
        this.draftState.activateDirectDebitAtMaturity.active = true;
        if (this.draftState.billingAgreements.data) {
            //TODO à revoir
            //this.draftState.data.directDebit = true;
            this.draftState.billingAgreements.data.dematerialization = demat;
        }
    };
    billingAgreementState.prototype.activateDirectDebitAtMaturityFailure = function (errorMessage) {
        this.draftState.iban.value = null;
        this.draftState.activateDirectDebitAtMaturity.loading = false;
        this.draftState.activateDirectDebitAtMaturity.active = false;
        this.draftState.activateDirectDebitAtMaturity.errorMessage =
            errorMessage;
    };
    billingAgreementState.prototype.resetDirectDebitAtMaturity = function () {
        this.draftState.iban.value = null;
        this.draftState.activateDirectDebitAtMaturity.loading = false;
        this.draftState.activateDirectDebitAtMaturity.active = false;
        this.draftState.activateDirectDebitAtMaturity.errorMessage = null;
    };
    /**
     * Succès de l'activation du prélèvement mensuel. Il s'agit du même succès quand on fait un switch
     * de prélèvement à échéance vers prélèvement mensuel
     *
     * @param demat Indique si dans sa demande l'utilisteur a demander aussi l'activation de la demat
     * @param wasDirectDebitAtMaturity flag indiquant si l'utilisateur était en prélèvement à échéance
     */
    billingAgreementState.prototype.activateDirectDebitSuccess = function (demat, wasDirectDebitAtMaturity, isEstimationAvailable, isMensuV2, response) {
        var _a;
        this.draftState.activateDirectDebit.loading = false;
        this.draftState.activateDirectDebit.active = true;
        this.draftState.activateDirectDebit.wasDirectDebitAtMaturity =
            wasDirectDebitAtMaturity;
        this.draftState.iban.value = null;
        this.draftState.iban.numberOfPeople = null;
        this.draftState.iban.withdrawalDate = null;
        if (this.draftState.billingAgreements.data) {
            this.draftState.billingAgreements.data.directDebit = true;
            this.draftState.billingAgreements.data.paymentMethodCode = 'periodic';
            this.draftState.billingAgreements.data.dematerialization = demat;
        }
        this.draftState.MandatSepaURL = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.MandatSepaURL) || null;
    };
    /**
     * Echec de l'activation du prélèvement automatique
     * @param errorMessage Message d'erreur
     */
    billingAgreementState.prototype.activateDirectDebitFailure = function (errorMessage) {
        this.draftState.iban.value = null;
        this.draftState.iban.numberOfPeople = null;
        this.draftState.iban.withdrawalDate = null;
        this.draftState.activateDirectDebit.loading = false;
        this.draftState.activateDirectDebit.active = false;
        this.draftState.activateDirectDebit.errorMessage = errorMessage;
        this.draftState.MandatSepaURL = null;
    };
    billingAgreementState.prototype.resetDirectDebit = function () {
        this.draftState.iban.value = null;
        this.draftState.iban.numberOfPeople = null;
        this.draftState.iban.withdrawalDate = null;
        this.draftState.iban.status = null;
        this.draftState.activateDirectDebit.loading = false;
        this.draftState.activateDirectDebit.active = false;
        this.draftState.activateDirectDebit.errorMessage = null;
        this.draftState.MandatSepaURL = null;
    };
    /**
     * Activation de la facture électronique uniquement.
     * Disponible pour les utilisateurs en prélèvement automatiques
     */
    billingAgreementState.prototype.activateElectronicInvoice = function () {
        this.draftState.activateElectronicInvoice.loading = true;
        this.draftState.activateElectronicInvoice.active = false;
        this.draftState.activateElectronicInvoice.errorMessage = null;
        this.draftState.activateElectronicInvoice.sent = false;
    };
    billingAgreementState.prototype.activateElectronicInvoiceFailure = function (errorMessage) {
        this.draftState.activateElectronicInvoice.loading = false;
        this.draftState.activateElectronicInvoice.active = false;
        this.draftState.activateElectronicInvoice.errorMessage = errorMessage;
        this.draftState.activateElectronicInvoice.sent = false;
    };
    billingAgreementState.prototype.activateElectronicInvoiceSuccess = function () {
        this.draftState.activateElectronicInvoice.loading = false;
        this.draftState.activateElectronicInvoice.active = true;
        this.draftState.activateElectronicInvoice.errorMessage = null;
        this.draftState.activateElectronicInvoice.sent = true;
        if (this.draftState.billingAgreements.data) {
            this.draftState.billingAgreements.data.dematerialization = true;
        }
    };
    /**
     * Action pour mettre fin à la facture électronique
     * Uniquement pour les clients ayant souscrits au service
     * @param payload - customerAccountId
     */
    billingAgreementState.prototype.terminateElectronicInvoice = function (payload) {
        this.draftState.terminateElectronicInvoice.loading = true;
        this.draftState.terminateElectronicInvoice.active = false;
        this.draftState.terminateElectronicInvoice.sent = false;
        this.draftState.terminateElectronicInvoice.errorMessage = null;
    };
    billingAgreementState.prototype.terminateElectronicInvoiceSuccess = function () {
        this.draftState.terminateElectronicInvoice.loading = false;
        this.draftState.activateElectronicInvoice.active = false;
        this.draftState.terminateElectronicInvoice.active = true;
        this.draftState.terminateElectronicInvoice.sent = true;
        this.draftState.terminateElectronicInvoice.errorMessage = null;
        if (this.draftState.billingAgreements.data) {
            this.draftState.billingAgreements.data.dematerialization = false;
        }
    };
    billingAgreementState.prototype.terminateElectronicInvoiceFailure = function (errorMessage) {
        this.draftState.terminateElectronicInvoice.loading = false;
        this.draftState.activateElectronicInvoice.active = true;
        this.draftState.terminateElectronicInvoice.active = false;
        this.draftState.terminateElectronicInvoice.sent = false;
        this.draftState.terminateElectronicInvoice.errorMessage = errorMessage;
    };
    billingAgreementState.prototype.activateEBill = function (payload) {
        this.draftState.activateElectronicInvoice.loading = true;
    };
    billingAgreementState.prototype.resetActivateElectronicInvoiceState = function () {
        this.draftState.activateElectronicInvoice.active = false;
        this.draftState.activateElectronicInvoice.errorMessage = null;
    };
    billingAgreementState.prototype.updateBillingAddress = function (payload) {
        this.draftState.billingAddress.loading = true;
    };
    billingAgreementState.prototype.updateBillingAddressSuccess = function () {
        this.draftState.billingAddress.loading = false;
        this.draftState.billingAddress.status = 'success';
    };
    billingAgreementState.prototype.updateBillingAddressFailure = function (err) {
        this.draftState.billingAddress.loading = false;
        this.draftState.billingAddress.errorMessage = err;
        this.draftState.billingAddress.status = 'failure';
    };
    billingAgreementState.prototype.resetupdateAddressResult = function () {
        this.draftState.billingAddress.status = 'none';
        this.draftState.billingAddress.loading = false;
        this.draftState.billingAddress.errorMessage = null;
    };
    billingAgreementState.prototype.updateIban = function (payload) {
        this.draftState.iban.loading = true;
    };
    billingAgreementState.prototype.updateIbanSuccess = function () {
        this.draftState.iban.loading = false;
        this.draftState.iban.status = 'success';
        this.draftState.iban.errorMessage = null;
    };
    billingAgreementState.prototype.updateIbanFailure = function (err) {
        this.draftState.iban.loading = false;
        this.draftState.iban.errorMessage = err;
        this.draftState.iban.status = 'failure';
    };
    /**
     * Action levée en cas d'IBAN invalid
     * @param err Message d'erreur adapté
     */
    billingAgreementState.prototype.updateIbanFailureInvalidIban = function (err) {
        this.draftState.iban.loading = false;
        this.draftState.iban.errorMessage = err;
        this.draftState.iban.status = 'invalid';
    };
    billingAgreementState.prototype.checkIbanValidity = function (newIban) {
        this.draftState.iban.loading = true;
    };
    billingAgreementState.prototype.checkIbanOffValidity = function (newIban) {
        this.draftState.iban.loading = true;
        this.draftState.iban.errorMessage = null;
        this.draftState.iban.status = 'none';
    };
    billingAgreementState.prototype.ibanIsValid = function () {
        this.draftState.iban.loading = false;
        this.draftState.iban.status = 'success';
        this.draftState.iban.errorMessage = null;
    };
    billingAgreementState.prototype.ibanIsNotValid = function (err) {
        this.draftState.iban.errorMessage = err;
        this.draftState.iban.loading = false;
        this.draftState.iban.status = 'invalid';
    };
    billingAgreementState.prototype.checkIbanValidityFailure = function (err) {
        this.draftState.iban.loading = false;
        this.draftState.iban.errorMessage = err;
        this.draftState.iban.status = 'failure';
    };
    billingAgreementState.prototype.resetUpdateIbanResult = function () {
        this.draftState.iban.status = 'none';
    };
    billingAgreementState.prototype.getBillingAddress = function (customerAccountId) {
        this.draftState.billingAddress.loading = true;
    };
    billingAgreementState.prototype.getBillingAddressSuccess = function (_address) {
        this.draftState.billingAddress.data = _address;
        this.draftState.billingAddress.loading = false;
        this.draftState.billingAddress.errorMessage = null;
    };
    billingAgreementState.prototype.getBillingAddressFailure = function (errorMSg) {
        this.draftState.billingAddress.loading = false;
        this.draftState.billingAddress.errorMessage = errorMSg;
    };
    billingAgreementState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    billingAgreementState.prototype.getMonthlyEstimateAmount = function (customerAccountId) {
        this.draftState.monthlyEstimate.loading = true;
        this.draftState.monthlyEstimate.success = null;
        this.draftState.monthlyEstimate.responseCode = null;
        this.draftState.monthlyEstimate.monthlyEstimateData = null;
        this.draftState.monthlyEstimate.errorMessage = null;
    };
    billingAgreementState.prototype.getMonthlyEstimateAmountSuccess = function (payload) {
        this.draftState.monthlyEstimate.loading = false;
        this.draftState.monthlyEstimate.success = true;
        this.draftState.monthlyEstimate.responseCode = payload.responseCode;
        this.draftState.monthlyEstimate.monthlyEstimateData = payload.data;
        this.draftState.monthlyEstimate.errorMessage = null;
    };
    billingAgreementState.prototype.getMonthlyEstimateAmountFailure = function (errorMsg, responseCode) {
        this.draftState.monthlyEstimate.loading = false;
        this.draftState.monthlyEstimate.success = false;
        this.draftState.monthlyEstimate.monthlyEstimateData = null;
        this.draftState.monthlyEstimate.responseCode = responseCode;
        this.draftState.monthlyEstimate.errorMessage = errorMsg;
    };
    return billingAgreementState;
}(immer_reducer_1.ImmerReducer));
exports.billingAgreementState = billingAgreementState;
exports.billingAgreementActions = (0, immer_reducer_1.createActionCreators)(billingAgreementState);
exports.billingAgreementReducerFunction = (0, immer_reducer_1.createReducerFunction)(billingAgreementState, exports.initialState);
